// @flow

import * as React from "react";
import { css } from "@emotion/core";
import moment from "moment";
import {fontSize} from "../../../Styles/text";
import mq from "../../../Styles/breakpoints";
import colors from "../../../Styles/colors";

const time = css`
  display: flex;
  z-index: 3;
  width: 100%;
  height: 100%;
  box-shadow:0 0 0 1px #ccc;
  background-color: white;
  justify-content: center;
  -ms-grid-column-align: center;
  -ms-grid-row-align: center;
  align-items: flex-start;
  padding-top: 40px;
  -ms-grid-column: 1;
  -ms-grid-column-span: 1;
  grid-column-start: 1;
  ${fontSize(6)};
  font-weight: bold;
  position: sticky;
  left:0;
  
  ${mq.large(`
    position: relative;
  `)};
  
  @media print {
    border: 1px solid ${colors.coreColor1};
  }
`;

type Props = {|
  msRows: Map<string, number>,
  rowCount: number,
  interval: number,
  start: number,
  loadTime: number,
  loadTimeRef: { current: null | React.ElementRef<'div'> }
|};

export default React.memo<Props>(function ScheduleTimes(props: Props) {
  let {
    msRows,
    rowCount,
    interval,
    start,
    loadTime,
    loadTimeRef
  } = props;

  let times = [];

  for (let i = 0; i < rowCount; i++) {
    let title = moment.unix(start).format('hh:mm A');

    let override = {
      // $FlowFixMe - Calls to get here are guaranteed, assuming the invariants of getGrid hold
      msGridRow: `${msRows.get(`time-${i}`)}`,
      msGridRowSpan: 1, gridRowStart: `time-${i}`,
      gridRowEnd: `${(i !== rowCount-  1) ? `time-${i + 1}` : 'span 1' }`
    };

    times.push(
      <div
        key={i}
        css={time}
        style={override}
        ref={i === loadTime ? loadTimeRef : null}
      >
        {title}
      </div>
    );

    start += interval * 60;
  }

  return times;
})